import getCustomerApi from '@/api/get/customer/get-customer';
import createContactPersonApi from '@/api/post/contact-person/create-contact-person';
import SubmitCard from '@/components/card/submit-card-component';
import Modal from '@/components/modal/modal-component';
import { useQuery } from '@/hooks/use-api';
import PropTypes from 'prop-types';
import { FormProvider, useForm } from 'react-hook-form';
import styled from 'styled-components';
import CustomerContactForm from '../customer-management/customer-contact-form';

const QuickCreateCustomerForm = ({ onClose, customerId }) => {
  const { data: customer, loading } = useQuery(getCustomerApi, customerId);
  const superiorOptions = customer?.contactPerson?.map((contact) => ({
    label: contact.name,
    value: contact.id,
  }));

  const methods = useForm({
    defaultValues: {
      name: '',
      email: '',
      contact_number: '',
      position: '',
      superior: '',
      customer_id: customerId,
      default_recipient_of_quotes: false,
    },
  });

  const onSubmit = (values) => {
    const submitValues = { ...values };

    createContactPersonApi(submitValues).then(({ data }) => {
      onClose(data?.id);
    });
  };

  return (
    <MainContainer xs={12}>
      <FormProvider {...methods}>
        <CustomerContactForm
          superiorOptions={superiorOptions}
          isLoading={loading}
        />
        <SubmitCard
          padding="0"
          primaryButtonTitle="Save"
          primaryButtonType="button"
          submitClick={methods.handleSubmit(onSubmit)}
          primaryButtonDisabled={false}
          primaryButtonWidth="112px"
          isLoading={false}
          secondaryButtonTitle="Cancel"
          secondaryButtonType="button"
          secondaryButtonWidth="112px"
          secondaryButtonDisabled={false}
          submitClickSecondary={() => {
            onClose();
          }}
        />
      </FormProvider>
    </MainContainer>
  );
};

QuickCreateCustomerForm.propTypes = {
  onClose: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
};

/**
 * Quick add customer contact form
 * @file quick-create-customer-contact.jsx
 * @param {boolean} open - open modal
 * @returns {JSX.Element} Quick add customer contact form
 */
const QuickCreateCustomerContact = ({ open, onClose, customerId }) => (
  <Modal
    width="400px"
    open={open}
    showClose
    bodyStyle={{
      padding: '0px',
    }}
    close={() => {
      onClose();
    }}
    title="Add Contact Person"
  >
    <QuickCreateCustomerForm onClose={onClose} customerId={customerId} />
  </Modal>
);

QuickCreateCustomerContact.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customerId: PropTypes.string.isRequired,
};

QuickCreateCustomerContact.defaultProps = {};

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ $margin }) => $margin};
  padding: ${({ $padding }) => $padding};
  height: fit-content;
  padding: 0px;
  width: 100%;
`;

export default QuickCreateCustomerContact;
